import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserPermissionsService } from '../../services/user-permissions.service';

@Directive({
  selector: '[appHasAnyPermission]',
})
export class HasAnyPermissionDirective implements OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private userPermissionsService = inject(UserPermissionsService);
  private permissionSub?: Subscription;

  private requiredPermissions: string[] = [];

  @Input() set appHasAnyPermission(roles: string | string[]) {
    this.requiredPermissions = Array.isArray(roles) ? roles : [roles];
    this.updateView();
  }

  private updateView(): void {
    if (this.requiredPermissions.length === 0) {
      this.permissionSub?.unsubscribe();
      this.viewContainer.clear();
      return;
    }

    this.permissionSub?.unsubscribe();
    this.permissionSub = this.userPermissionsService.hasAnyPermission(this.requiredPermissions).subscribe(hasPermission => {
      if (hasPermission) {
        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        this.viewContainer.clear();
      }
    });
  }

  ngOnDestroy(): void {
    this.permissionSub?.unsubscribe();
  }
}
